/** Grymwyrd — polski tekst do funkcji Play / VTT. */
export const playPl = {
  // CampaignList
  'play.campaigns.heading': 'Moje Kampanie',
  'play.campaigns.signIn': 'Zaloguj się',
  'play.campaigns.signInToSee': 'aby zobaczyć kampanie, do których się przyłączyłeś.',
  'play.campaigns.fallbackNotice': 'Wyświetlane są przykładowe kampanie — Twoja lista nie mogła zostać załadowana.',
  'play.campaigns.loading': 'Przywołuję Twoje sagi…',
  'play.campaigns.empty': 'Nie przyłączyłeś się jeszcze do żadnej kampanii.',
  'play.campaigns.assignedCharacter': 'Przypisana Postać',
  'play.campaigns.unassigned': 'Nieprzypisana',
  'play.campaigns.noCharactersYet': 'Brak postaci',
  'play.campaigns.enterCampaign': 'Wejdź do kampanii',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': 'Stół',
  'play.vtt.launch': 'Uruchom VTT',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — kampania {campaignId}',
  'play.vtt.veilHeadline': 'Zasłona między stołem a opowieścią jest tu cienka.',
  'play.vtt.prototypeIntro':
    'Działający w czasie rzeczywistym wirtualny stół jest etapem przyszłym. Interaktywny prototyp będzie osadzony w tej ramce — naciśnij',
  'play.vtt.prototypeOutro': 'aby przygotować kontener.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': 'Kodeks — Szybkie Wyszukiwanie',
  'play.codex.searchPlaceholder': 'Wyszukaj potwora, zaklęcie, zasadę…',
  'play.codex.searchAriaLabel': 'Przeszukaj encyklopedię',
  'play.codex.searching': 'Czytam przyszłość…',
  'play.codex.noResults': 'Brak wyników dla „{q}".',
  'play.codex.hint': 'Wpisz co najmniej dwie litery, aby przeszukać żywą encyklopedię, nie opuszczając stołu.',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': 'Kampania',
  'play.campaign.fallbackDescription':
    'Szczegóły kampanii nie mogły zostać załadowane — możesz przygotować swoją postać poniżej.',
  'play.campaign.seoTitle': 'Kampania',
  'play.campaign.noneSpecified': 'Żadna kampania nie została określona.',
  'play.campaign.seoTitleNamed': '{title} — Gra',
  'play.campaign.seoTitleDefault': 'Kampania — Gra',
  'play.campaign.backToLobby': 'Powrót do lobby',
  'play.campaign.gm': 'MG {gm}',
  'play.campaign.playersCount': '{count} graczy',

  // CharacterSheet
  'play.sheet.savedToCodex': 'Zapisano w Twoim kodeksie.',
  'play.sheet.savedLocally': 'Zapisano lokalnie (serwer niedostępny).',
  'play.sheet.saveError': 'Nie udało się zapisać Twojej postaci — magazyn jest niedostępny.',
  'play.sheet.loading': 'Rozwijam kartę…',
  'play.sheet.heading': 'Karta Postaci',
  'play.sheet.avatarAlt': 'Avatar {name}',
  'play.sheet.unclaimedHero': 'Nieuznana bohaterka',
  'play.sheet.abilityCheck': 'Test {ability} ({formula}):',
  'play.sheet.name': 'Imię',
  'play.sheet.namePlaceholder': 'Bezimiennego włóczęgę',
  'play.sheet.level': 'Poziom',
  'play.sheet.speciesLabel': 'Pochodzenie / Gatunek',
  'play.sheet.loadingOption': 'Ładuję…',
  'play.sheet.selectSpecies': 'Wybierz gatunek',
  'play.sheet.classLabel': 'Klasa',
  'play.sheet.selectClass': 'Wybierz klasę',
  'play.sheet.abilityScores': 'Atrybuty',
  'play.sheet.abilityScoresHint': '(kliknij modifier, aby rzucić)',
  'play.sheet.abilityScoreAria': 'Atrybut {ability}',
  'play.sheet.rollCheckAria': 'Rzuć test {ability}',
  'play.sheet.hp': 'PŻ',
  'play.sheet.maxHp': 'Maks PŻ',
  'play.sheet.ac': 'KO',
  'play.sheet.backstory': 'Historia',
  'play.sheet.backstoryPlaceholder': 'Jaka ciemność przywiodła tę duszę do stołu?',
  'play.sheet.canonCandidate': 'Kandydat do Kanonu',
  'play.sheet.canonCandidateHint': 'Włącz tę postać do rozważenia jako część żywego kanonu Grymwyrd.',
  'play.sheet.saving': 'Zapisuję…',
  'play.sheet.saveCharacter': 'Zapisz Postać',

  // CreateGameModal
  'play.create.errorNoName': 'Daj swojemu stołowi nazwę.',
  'play.create.errorNoSystem': 'Wybierz system gry.',
  'play.create.you': 'Ty',
  'play.create.errorCreate': 'Rytuał się nie powiódł — Twój stół nie mógł być utworzony. Spróbuj za chwilę.',
  'play.create.modalTitle': 'Zwołaj Stół',
  'play.create.successCopy': 'Twój stół jest gotów. Udostępnij ten link zaproszenia, aby wezwać graczy.',
  'play.create.copyInviteAria': 'Skopiuj link zaproszenia',
  'play.create.copied': 'Skopiowano',
  'play.create.copy': 'Kopiuj',
  'play.create.done': 'Gotowe',
  'play.create.tableName': 'Nazwa Stołu',
  'play.create.tableNamePlaceholder': 'np. Skarbiec Żałoby',
  'play.create.quickStart': 'Szybki Start',
  'play.create.quickStartAria': 'Zestawy szybkiego startu',
  'play.create.customPreset': 'Niestandardowy',
  'play.create.customPresetDesc': 'Zacznij od zera',
  'play.create.gameSystem': 'System Gry',
  'play.create.loadingSystems': 'Ładuję systemy…',
  'play.create.systemFromPreset': '{system} (z zestawu)',
  'play.create.systemDefault': 'Grymwyrd Kataklizm (domyślnie)',
  'play.create.tags': 'Znaczniki',
  'play.create.tagsUpTo': '(do {count})',
  'play.create.removeTagAria': 'Usuń znacznik {tag}',
  'play.create.tagLimitReached': 'Limit znaczników osiągnięty',
  'play.create.tagPlaceholder': 'horror, oneshot…',
  'play.create.maxPlayers': 'Maks Graczy:',
  'play.create.cancel': 'Anuluj',
  'play.create.convening': 'Zwołuję…',
  'play.create.createTable': 'Stwórz Stół',

  // JoinPage
  'play.join.finding': 'Szukam stołu…',
  'play.join.expiredHeading': 'To zaproszenie wygasło',
  'play.join.expiredBody': 'Kody wygasają dla bezpieczeństwa. Poproś gospodarza o świeży kod.',
  'play.join.browseLiveTables': 'Przejrzyj stały stoły',
  'play.join.errorHeading': 'Nie mogliśmy dotrzeć do stołu',
  'play.join.errorBody': 'Coś poszło nie tak przy wyszukiwaniu zaproszenia. Sprawdź połączenie i spróbuj ponownie.',
  'play.join.tryAgain': 'Spróbuj ponownie',
  'play.join.defaultTableTitle': 'Stół Grymwyrd',
  'play.join.invited': 'Zostałeś zaproszony, aby zająć miejsce.',
  'play.join.signInToSeat': 'Zaloguj się, aby zająć miejsce',
  'play.join.createAccount': 'Nowy tutaj? Utwórz bezpłatne konto',
  'play.join.opensAfterSignIn': 'Stół otwiera się po zalogowaniu.',

  // PlayLobbyPage
  'play.lobby.seoTitle': 'Gra — Wirtualny Stół',
  'play.lobby.seoDescription':
    'Znajdź stół, dołącz do sesji na żywo i stwórz swoją legendę na wirtualnym stole Grymwyrd.',
  'play.lobby.eyebrow': 'Wirtualny Stół',
  'play.lobby.title': 'Gra',
  'play.lobby.subtitle':
    'Zbierz swoją konwię. Rzuć kości. Zajmij miejsce przy stole, gdzie każdy wybór rozchodzi się przez żywy kanon Grymwyrd.',
  'play.lobby.createGame': 'Stwórz Grę',
  'play.lobby.playNow': 'Graj Teraz — bez konta',
  'play.lobby.signInToHost': 'Zaloguj się, aby prowadzić swój stół',

  // SessionListLive
  'play.live.heading': 'Na Żywo Teraz',
  'play.live.empty': 'O tej porze żadne stoły nie są na żywo. Zasłona jest cicha — zacznij swój własny.',
  'play.live.badge': 'Na żywo',
  'play.live.unknownSystem': 'Nieznany system',
  'play.live.gmSuffix': ' · MG {gm}',
  'play.live.players': 'graczy',

  // TableList — empty board
  'play.tables.emptyHeading': 'Brak otwartych stołów',
  'play.tables.emptyBody':
    'Tablica jest spokojna. Bądź pierwszy i pull up a chair — spróbuj gościnnego stołu natychmiast, bez konta.',
  'play.tables.tryGuestTable': 'Spróbuj gościnnego stołu',
  'play.tables.orUse': 'Lub użyj',
  'play.tables.createGame': 'Stwórz Grę',
  'play.tables.aboveToHost': 'powyżej, aby prowadzić swój własny.',

  // TableList — waitlist
  'play.waitlist.joinError': 'Nie udało się dołączyć do listy oczekujących — spróbuj ponownie.',
  'play.waitlist.leaveError': 'Nie udało się opuścić listę oczekujących — spróbuj ponownie.',
  'play.waitlist.join': 'Dołącz do listy oczekujących',
  'play.waitlist.leaving': 'Odchodzę…',
  'play.waitlist.leave': 'Opuść listę oczekujących',
  'play.waitlist.joining': 'Dołączam…',

  // TableList — board
  'play.tables.heading': 'Otwarte Stoły',
  'play.tables.openSeatOnly': 'Tylko otwarte miejsce',
  'play.tables.systemFilterPlaceholder': 'System…',
  'play.tables.systemFilterAria': 'Filtruj po systemie',
  'play.tables.tagsFilterPlaceholder': 'Znaczniki (rozdzielone przecinkami)…',
  'play.tables.tagsFilterAria': 'Filtruj po znacznikach',
  'play.tables.fetchError': 'Nie mogliśmy dotrzeć do żywej tablicy — lobby jest tymczasowo niedostępne.',
  'play.tables.loading': 'Zbieriam stoły…',
  'play.tables.untitledTable': 'Stół bez nazwy',
  'play.tables.full': 'Pełny',
  'play.tables.seatedCount': '{count} siedzących',
  'play.tables.viewTable': 'Pokaż Stół',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': 'Czat Stołu',
  'chat.empty': 'Brak wiadomości. Powiedz coś stołowi.',
  'chat.inputPlaceholder': 'Wiadomość do stołu…',
  'chat.inputAria': 'Wiadomość czatu',
  'chat.send': 'Wyślij',
  'chat.translatedFrom': 'Przetłumaczono z {lang}',
  'chat.original': 'Oryginalne',
  'chat.showOriginal': 'Pokaż oryginał',
  'chat.showTranslation': 'Pokaż tłumaczenie',
  'chat.showOriginalsAll': 'Pokaż oryginały',
  'chat.showTranslationsAll': 'Pokaż tłumaczenia',
}
